module.exports = __webpack_public_path__ + "static/img/model2-1.a4b2020d.jpg";